import React, { useState, useEffect } from 'react';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { ReactComponent as Frame } from '../icons/frame.svg';
import { NotificationType } from './notification-dropdown';
import useRoleContext from 'contexts/role.context';
import { apiService } from 'utils/api';
import moment from 'moment';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

type NotificationProps = {
  onClose: () => void;
};

const NotificationSideModal = ({ onClose }: NotificationProps) => {
  const [lastestNotifications, setLatestNotifications] = useState([] as NotificationType[]);
  const [loading, setLoading] = useState(false);
  const [isUnread] = useState(false);
  const { role } = useRoleContext();

  const getAllNotifications = async () => {
    setLoading(true);
    if (role === ENUM_ROLE.CS_ADMIN || role === ENUM_ROLE.SUPER_ADMIN) {
      const res = await apiService.get('cs/notification', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setLatestNotifications(res.data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllNotifications();
  }, [role]);

  const formatTime = (timestamp: Date) => {
    const dateObj = moment(timestamp);
    const timeString = dateObj.format('h:mmA');
    const today = moment();
    const isToday = dateObj.isSame(today, 'day');

    return isToday ? `Today, ${timeString}` : dateObj.format('MMM D, h:mmA');
  };

  return (
    <BaseModal position='right' isOpen title='Notifications' onRequestClose={onClose}>
      <div>
        <h2 className='text-xs text-[#858585] mb-4'>Latest Updates</h2>
        {loading && <div className='text-[#858585] text-sm my-4'>Loading ...</div>}
        {lastestNotifications
          .sort(
            (a: NotificationType, b: NotificationType) =>
              new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          )
          .map((item) => (
            <div
              key={item.id}
              className='flex justify-between w-full items-center gap-3 py-3 cursor-pointer'>
              <div className='flex gap-3'>
                <div className='bg-[#F4F1F1] min-w-[30px] h-[27px] rounded-full flex justify-center items-center'>
                  <Frame />
                </div>
                <div className='flex flex-col gap-1'>
                  <p className='text-[#595959] text-sm'>{item.details}</p>
                  <p className='text-[#737373] text-[10px]'>{formatTime(item.created_at)}</p>
                </div>
              </div>

              {isUnread && <div className='min-w-[10px] h-[10px] bg-[#E60A2B] rounded-full '></div>}
            </div>
          ))}
      </div>
      {/* TODO :: REFACTOR AFTER MIGRATION */}
      {/* <div>
        <h2 className='text-xs text-[#858585] mt-6 mb-4'>This Week</h2>
        {weeklyNotifications
          .sort(
            (a: NotificationType, b: NotificationType) =>
              new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          )
          .map((item) => (
            <div
              key={item.id}
              className='flex justify-between w-full items-center gap-3 py-3 cursor-pointer'>
              <div className='flex gap-3'>
                <div className='bg-[#F4F1F1] min-w-[30px] h-[27px] rounded-full flex justify-center items-center'>
                  <Frame />
                </div>
                <div className='flex flex-col gap-1'>
                  <p className='text-[#595959] text-sm'>{item.details}</p>
                  <p className='text-[#737373] text-[10px]'>{formatTime(item.created_at)}</p>
                </div>
              </div>

              {isUnread && <div className='min-w-[10px] h-[10px] bg-[#E60A2B] rounded-full '></div>}
            </div>
          ))}
      </div> */}
    </BaseModal>
  );
};

export default NotificationSideModal;
